import isNil from 'lodash/isNil';
import assert from './assert';

/**
 * Ensures the given value is either `null` or `undefined`
 * @param value The value to check
 * @param message (Optional) An error message to throw if the value fails the check
 * @returns Throws an AssertionError if the check fails
 */
export default (value: unknown, message?: string) =>
  assert(isNil(value), message || `Expected null or undefined, got '${value}'`);
